/* eslint-disable react/require-default-props */
import React from 'react';
import propTypes from 'prop-types';
import { CardCtaLoader } from './subcomponents/CardCtaLoader';
import { PodCtaLoader } from './subcomponents/PodCtaLoader';

const { string, bool } = propTypes;

export const PromotionProductsLoader = ({ experienceTag = null, subExperienceTag = null, type }) => {
  const isCard = type === 'card';

  return isCard ? (
    <CardCtaLoader />
  ) : (
    <PodCtaLoader experienceTag={experienceTag} subExperienceTag={subExperienceTag} />
  );
};

PromotionProductsLoader.displayName = 'PromotionProductsLoader';

PromotionProductsLoader.propTypes = {
  experienceTag: string,
  subExperienceTag: string,
  type: string.isRequired,
};
